/**
 * gift-cart-tier.js
 * Gère l'ajout/retrait automatique des cadeaux avec CHOIX au palier 2
 * + Animation Confettis (Dopamine Hit) lors de l'atteinte des paliers et du choix.
 */

((document) => {
    'use strict';

    /**
     * Animation de Confettis ultra-légère en Canvas HTML5
     */
    function launchConfetti() {
        try {
            const canvas = document.createElement('canvas');
            canvas.style.position = 'fixed';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvas.style.width = '100vw';
            canvas.style.height = '100vh';
            canvas.style.pointerEvents = 'none';
            canvas.style.zIndex = '999999';
            document.body.appendChild(canvas);

            const ctx = canvas.getContext('2d');
            const width = canvas.width = window.innerWidth;
            const height = canvas.height = window.innerHeight;

            const colors = ['#10b981', '#ec4899', '#8b5cf6', '#f59e0b', '#3b82f6', '#ef4444', '#14b8a6'];
            const particles = [];
            const particleCount = 80;

            for (let i = 0; i < particleCount; i++) {
                particles.push({
                    x: Math.random() * width,
                    y: Math.random() * height * 0.3 - height * 0.1,
                    w: Math.random() * 10 + 5,
                    h: Math.random() * 6 + 4,
                    vx: (Math.random() - 0.5) * 6,
                    vy: Math.random() * 4 + 3,
                    rotation: Math.random() * 360,
                    rotationSpeed: (Math.random() - 0.5) * 10,
                    color: colors[Math.floor(Math.random() * colors.length)],
                    opacity: 1,
                    decay: Math.random() * 0.015 + 0.008
                });
            }

            let animationFrame;
            const startTime = Date.now();

            function render() {
                const elapsed = Date.now() - startTime;
                ctx.clearRect(0, 0, width, height);

                let activeCount = 0;

                particles.forEach(p => {
                    if (p.opacity <= 0) return;
                    activeCount++;

                    p.x += p.vx;
                    p.y += p.vy;
                    p.rotation += p.rotationSpeed;
                    if (elapsed > 1000) {
                        p.opacity -= p.decay;
                    }

                    ctx.save();
                    ctx.translate(p.x, p.y);
                    ctx.rotate((p.rotation * Math.PI) / 180);
                    ctx.globalAlpha = Math.max(0, p.opacity);
                    ctx.fillStyle = p.color;
                    ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
                    ctx.restore();
                });

                if (activeCount > 0 && elapsed < 3000) {
                    animationFrame = requestAnimationFrame(render);
                } else {
                    cancelAnimationFrame(animationFrame);
                    if (canvas.parentNode) {
                        canvas.parentNode.removeChild(canvas);
                    }
                }
            }

            render();
        } catch (e) {
            console.error('[confetti]', e);
        }
    }

    /**
     * Lit les paramètres du snippet depuis les data-attributes du wrapper
     */
    function getConfig() {
        const wrapper = document.querySelector('.cart-tier-progress-wrapper');
        if (!wrapper) {
            return null;
        }

        const threshold1 = parseInt(wrapper.getAttribute('data-threshold-1') || '3900', 10);
        const giftId1 = parseInt(wrapper.getAttribute('data-gift-id-1') || '0', 10);

        const threshold2 = parseInt(wrapper.getAttribute('data-threshold-2') || wrapper.getAttribute('data-threshold') || '4900', 10);
        const giftId2 = parseInt(wrapper.getAttribute('data-gift-id-2') || wrapper.getAttribute('data-gift-id') || '0', 10);

        return { threshold1, giftId1, threshold2, giftId2 };
    }

    /**
     * Rafraîchit le drawer mini-cart via le mécanisme natif Focal
     * (CartDrawer._rerenderCart) et met à jour le compteur du header.
     */
    function refreshDrawer() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) {
            window.location.reload();
            return;
        }
        
        setTimeout(() => {
            drawer.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { replacementDelay: 400 }
            }));
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    document.documentElement.dispatchEvent(
                        new CustomEvent('cart:updated', {
                            bubbles: true,
                            detail: { cart }
                        })
                    );
                })
                .catch(err => {});
        }, 500);
    }

    /**
     * Calcule le sous-total du panier en excluant les produits cadeaux
     * pour éviter d'influencer le calcul des seuils.
     */
    function getNonGiftSubtotal(cart, giftIds) {
        return (cart.items || []).reduce((sum, item) => {
            const isGiftProduct = giftIds.some(id => id > 0 && (item.variant_id == id || item.id == id));
            const isOfficialGift = item.properties && item.properties._is_gift === 'true';
            const isCouponGift = item.properties && item.properties._source === 'coupon_gift';
            
            if (isGiftProduct && (isOfficialGift || isCouponGift)) {
                return sum;
            }
            return sum + item.final_line_price;
        }, 0);
    }

    let isUpdating = false;
    let pendingCart = null;
    let celebratedTier1 = sessionStorage.getItem('kea_celebrated_t1') === 'true';
    let celebratedTier2 = sessionStorage.getItem('kea_celebrated_t2') === 'true';

    // Mémorise en temps réel l'état du panier pour la vérification synchrone au checkout
    let lastCartTotal = null;    // sous-total hors cadeaux (en centimes)
    let lastHasChoice = false;   // true si un cadeau de choix est déjà dans le panier

    /**
     * Vérifie l'état du panier et gère les cadeaux automatiquement.
     */
    async function checkGift(cart) {
        const config = getConfig();
        if (!config) return;
        if (isUpdating) return;

        const { threshold1, giftId1, threshold2, giftId2 } = config;
        const total = getNonGiftSubtotal(cart, [giftId1, giftId2]);
        const allItems = cart.items || [];

        // Mettre à jour l'état mémorisé pour la vérification synchrone au checkout
        lastCartTotal = total;
        lastHasChoice = allItems.some(item =>
            item.properties &&
            item.properties._gift_choice === 'true' &&
            item.properties._is_gift === 'true'
        );
        // Déclencher les confettis la 1ère fois que le panier franchit un palier dans la session
        if (total >= threshold2 && !celebratedTier2) {
            celebratedTier2 = true;
            sessionStorage.setItem('kea_celebrated_t2', 'true');
            setTimeout(launchConfetti, 300);
        } else if (total >= threshold1 && total < threshold2 && !celebratedTier1) {
            celebratedTier1 = true;
            sessionStorage.setItem('kea_celebrated_t1', 'true');
            setTimeout(launchConfetti, 300);
        }

        // Trouver le cadeau auto du palier 1 (SANS _gift_choice)
        const autoGift1 = giftId1 > 0 ? allItems.find(item =>
            (item.variant_id == giftId1 || item.id == giftId1) &&
            item.properties && item.properties._is_gift === 'true' &&
            (!item.properties._gift_choice || item.properties._gift_choice !== 'true')
        ) : null;

        // Trouver les cadeaux choisis au palier 2 (AVEC _gift_choice)
        const choiceGifts = allItems.filter(item =>
            item.properties && item.properties._gift_choice === 'true' && item.properties._is_gift === 'true' &&
            ((giftId1 > 0 && (item.variant_id == giftId1 || item.id == giftId1)) ||
             (giftId2 > 0 && (item.variant_id == giftId2 || item.id == giftId2)))
        );

        const itemsToAdd = [];
        const updates = {};
        let needsUpdate = false;
        let discountToApply = null;

        if (total >= threshold2) {
            // === PALIER 2 : MODE CHOIX ===
            if (autoGift1) {
                updates[autoGift1.key] = 0;
                needsUpdate = true;
            }

            for (const cg of choiceGifts) {
                if (cg.quantity !== 1) {
                    updates[cg.key] = 1;
                    needsUpdate = true;
                }
            }

        } else if (total >= threshold1) {
            // === PALIER 1 : MODE AUTO ===
            for (const cg of choiceGifts) {
                updates[cg.key] = 0;
                needsUpdate = true;
            }

            if (!autoGift1 && giftId1 > 0) {
                itemsToAdd.push({ id: giftId1, quantity: 1, properties: { '_is_gift': 'true' } });
                discountToApply = 'GIFT-SECRET-39';
            } else if (autoGift1 && autoGift1.quantity !== 1) {
                updates[autoGift1.key] = 1;
                needsUpdate = true;
            }

        } else {
            // === EN DESSOUS DU PALIER 1 ===
            if (autoGift1) {
                updates[autoGift1.key] = 0;
                needsUpdate = true;
            }
            for (const cg of choiceGifts) {
                updates[cg.key] = 0;
                needsUpdate = true;
            }
            sessionStorage.removeItem('kea_celebrated_t1');
            sessionStorage.removeItem('kea_celebrated_t2');
            celebratedTier1 = false;
            celebratedTier2 = false;
        }

        // Exécuter les changements
        if (itemsToAdd.length > 0 || (needsUpdate && Object.keys(updates).length > 0)) {
            isUpdating = true;
            try {
                if (needsUpdate && Object.keys(updates).length > 0) {
                    const updateRes = await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates })
                    });
                    if (!updateRes.ok) {
                        window.location.reload();
                        isUpdating = false;
                        return;
                    }
                }

                if (itemsToAdd.length > 0) {
                    const addRes = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: itemsToAdd })
                    });
                    if (!addRes.ok) {
                        window.location.reload();
                        isUpdating = false;
                        return;
                    }

                    if (discountToApply) {
                        await fetch('/discount/' + discountToApply);
                    }
                }

                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: {} })
                });

                refreshDrawer();
            } catch (e) {
                console.error('[gift-tier]', e);
            }
            isUpdating = false;
        }
    }

    /**
     * Gère le clic du client sur une carte de choix cadeau + lance les confettis !
     */
    async function chooseGift(chosenGiftId) {
        if (isUpdating) return;
        isUpdating = true;

        launchConfetti();

        const config = getConfig();
        if (!config) { isUpdating = false; return; }

        const { giftId1, giftId2 } = config;

        try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();

            const updates = {};
            for (const item of cart.items) {
                if (item.properties && item.properties._is_gift === 'true') {
                    const isGift = (item.variant_id == giftId1 || item.id == giftId1 ||
                                    item.variant_id == giftId2 || item.id == giftId2);
                    if (isGift) {
                        updates[item.key] = 0;
                    }
                }
            }

            if (Object.keys(updates).length > 0) {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                });
            }

            const addRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: chosenGiftId,
                        quantity: 1,
                        properties: { '_is_gift': 'true', '_gift_choice': 'true' }
                    }]
                })
            });

            if (addRes.ok) {
                if (chosenGiftId == giftId1) {
                    await fetch('/discount/GIFT-SECRET-39');
                } else if (chosenGiftId == giftId2) {
                    await fetch('/discount/GIFT-SECRET-779338892');
                }

                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: {} })
                });

                refreshDrawer();
            } else {
                window.location.reload();
            }
        } catch (e) {
            console.error('[gift-tier] chooseGift error:', e);
            window.location.reload();
        }

        isUpdating = false;
    }

    /**
     * Popup de rappel cadeau avant paiement
     */
    function showGiftReminderPopup(onContinue) {
        // Éviter les doublons
        if (document.getElementById('kea-gift-reminder-modal')) {
            onContinue();
            return;
        }

        const overlay = document.createElement('div');
        overlay.id = 'kea-gift-reminder-modal';
        overlay.style.cssText = [
            'position:fixed',
            'inset:0',
            'z-index:2147483647',
            'display:flex',
            'align-items:center',
            'justify-content:center',
            'background:rgba(0,0,0,0.55)',
            'backdrop-filter:blur(4px)',
            '-webkit-backdrop-filter:blur(4px)',
            'padding:20px',
            'animation:keaFadeIn 0.25s ease'
        ].join(';');

        const style = document.createElement('style');
        style.textContent = [
            '@keyframes keaFadeIn{from{opacity:0}to{opacity:1}}',
            '@keyframes keaSlideUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}',
            '#kea-gift-reminder-modal .kea-modal-box{',
            '  background:#fff;',
            '  border-radius:20px;',
            '  padding:36px 30px 28px;',
            '  max-width:400px;',
            '  width:100%;',
            '  text-align:center;',
            '  box-shadow:0 20px 60px rgba(0,0,0,0.25);',
            '  animation:keaSlideUp 0.3s ease;',
            '  position:relative;',
            '}',
            '#kea-gift-reminder-modal .kea-modal-emoji{',
            '  font-size:52px;',
            '  line-height:1;',
            '  margin-bottom:16px;',
            '  display:block;',
            '}',
            '#kea-gift-reminder-modal .kea-modal-title{',
            '  font-size:1.25rem;',
            '  font-weight:700;',
            '  color:#111;',
            '  margin:0 0 10px;',
            '  line-height:1.3;',
            '}',
            '#kea-gift-reminder-modal .kea-modal-text{',
            '  font-size:0.92rem;',
            '  color:#555;',
            '  margin:0 0 24px;',
            '  line-height:1.55;',
            '}',
            '#kea-gift-reminder-modal .kea-modal-text strong{color:#ec4899;}',
            '#kea-gift-reminder-modal .kea-btn-choose{',
            '  display:block;',
            '  width:100%;',
            '  padding:14px;',
            '  background:linear-gradient(135deg,#ec4899,#8b5cf6);',
            '  color:#fff;',
            '  font-weight:700;',
            '  font-size:0.95rem;',
            '  border:none;',
            '  border-radius:12px;',
            '  cursor:pointer;',
            '  margin-bottom:12px;',
            '  transition:opacity 0.2s;',
            '}',
            '#kea-gift-reminder-modal .kea-btn-choose:hover{opacity:0.88;}',
            '#kea-gift-reminder-modal .kea-btn-skip{',
            '  display:block;',
            '  width:100%;',
            '  padding:11px;',
            '  background:none;',
            '  color:#888;',
            '  font-size:0.83rem;',
            '  border:1px solid #e0e0e0;',
            '  border-radius:10px;',
            '  cursor:pointer;',
            '  transition:background 0.2s,color 0.2s;',
            '}',
            '#kea-gift-reminder-modal .kea-btn-skip:hover{background:#f5f5f5;color:#444;}',
        ].join('\n');
        document.head.appendChild(style);

        overlay.innerHTML = [
            '<div class="kea-modal-box">',
            '  <span class="kea-modal-emoji">🎁</span>',
            '  <p class="kea-modal-title">Attendez, vous avez un cadeau !</p>',
            '  <p class="kea-modal-text">',
            '    Votre commande dépasse <strong>49 €</strong> et vous avez droit à un',
            '    <strong>cadeau gratuit</strong> que vous n\'avez pas encore choisi.<br><br>',
            '    Êtes-vous sûre de vouloir continuer sans votre cadeau ?',
            '  </p>',
            '  <button class="kea-btn-choose" id="kea-modal-btn-choose">🎀 Je veux mon cadeau gratuit !</button>',
            '  <button class="kea-btn-skip" id="kea-modal-btn-skip">Non merci, continuer sans cadeau</button>',
            '</div>'
        ].join('');

        document.body.appendChild(overlay);

        document.getElementById('kea-modal-btn-choose').addEventListener('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            overlay.remove();
            style.remove();

            // S'assurer que le drawer reste bien ouvert
            const drawer = document.getElementById('mini-cart');
            if (drawer) {
                drawer.classList.add('is-open');
                drawer.removeAttribute('hidden');
                drawer.setAttribute('aria-hidden', 'false');
            }

            // Scroller vers les cartes de choix cadeau dans le drawer
            setTimeout(function() {
                const choiceSection = document.querySelector('.cart-tier-choice-section, [data-gift-choice]');
                if (choiceSection) {
                    choiceSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        });

        document.getElementById('kea-modal-btn-skip').addEventListener('click', function() {
            overlay.remove();
            style.remove();
            onContinue();
        });

        overlay.addEventListener('click', function(e) {
            if (e.target === overlay) {
                overlay.remove();
                style.remove();
            }
        });
    }

    /**
     * Vérifie si la cliente a droit à un cadeau de choix mais ne l'a pas encore choisi
     */
    async function hasUnclaimedChoiceGift() {
        const config = getConfig();
        if (!config) return false;

        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            const { threshold2, giftId1, giftId2 } = config;
            const total = getNonGiftSubtotal(cart, [giftId1, giftId2]);

            if (total < threshold2) return false;

            const hasChoice = (cart.items || []).some(item =>
                item.properties &&
                item.properties._gift_choice === 'true' &&
                item.properties._is_gift === 'true'
            );

            return !hasChoice;
        } catch (e) {
            return false;
        }
    }

    /**
     * Interception du bouton Payer (checkout)
     * IMPORTANT : e.preventDefault() doit être appelé de façon SYNCHRONE
     * avant tout await, sinon le navigateur ignore le blocage.
     */
    document.addEventListener('click', function(e) {
        const checkoutBtn = e.target.closest('.checkout-button[name="checkout"], button[name="checkout"]');
        if (!checkoutBtn) return;

        const config = getConfig();
        if (!config) return;

        // Bloquer IMMÉDIATEMENT (synchrone) si le seuil 2 est potentiellement atteint
        // On utilise le sous-total mémorisé lors du dernier cart:updated
        if (lastCartTotal !== null && lastCartTotal >= config.threshold2 && !lastHasChoice) {
            e.preventDefault();
            e.stopImmediatePropagation();

            showGiftReminderPopup(function() {
                // La cliente veut quand même payer sans cadeau
                const form = document.getElementById('mini-cart-form') ||
                             checkoutBtn.closest('form');
                if (form) {
                    form.submit();
                } else {
                    window.location.href = '/checkout';
                }
            });
        }
    }, true); // capture phase = synchrone, avant le submit natif

    /**
     * Clic sur carte de choix cadeau
     */
    document.addEventListener('click', function(e) {
        const card = e.target.closest('[data-gift-choice]');
        if (!card) return;

        e.preventDefault();
        const giftId = parseInt(card.getAttribute('data-gift-id'));
        if (!giftId || giftId <= 0) return;

        if (card.classList.contains('gift-choice-card--selected')) return;

        const allCards = document.querySelectorAll('[data-gift-choice]');
        allCards.forEach(c => {
            c.style.opacity = '0.6';
            c.style.pointerEvents = 'none';
        });

        chooseGift(giftId);
    });

    /**
     * Initialisation
     */
    function tryInit() {
        if (getConfig()) {
            setTimeout(() => {
                if (pendingCart) {
                    checkGift(pendingCart);
                    pendingCart = null;
                } else {
                    fetch('/cart.js')
                        .then(res => res.json())
                        .then(cart => {
                            checkGift(cart);
                        })
                        .catch(err => {});
                }
            }, 800);
            return true;
        }
        return false;
    }

    document.documentElement.addEventListener('cart:updated', (event) => {
        if (event.detail && event.detail.cart) {
            const config = getConfig();
            if (config) {
                checkGift(event.detail.cart);
            } else {
                pendingCart = event.detail.cart;
            }
        }
    });

    if (!tryInit()) {
        const observer = new MutationObserver(() => {
            if (tryInit()) {
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

})(document);